export default "__VITE_ASSET__10a4609c__"